import { API_URL } from "../../../constants";
import * as httpNetworking from "../../../httpNetworking";

const URL = API_URL + "/auth/email/otp";
const VERSION = 0;

export type AuthEmailOTPResponse =
    | {
          emailExists: true;
          loginFlowId: string;
      }
    | {
          emailExists: false;
      };

export async function sendEmailOTP(email: string): Promise<AuthEmailOTPResponse> {
    let options: httpNetworking.POSTRequestConfig = {
        timeout: 10000
    };

    let params = {
        email
    };

    let response = (await httpNetworking.simplePOSTRequest(URL, params, options, VERSION)).data;
    return response;
}
//commnet
